import { useRef, useState } from "react";
import "../blocks/modalWithForm/modalWithForm.css";
import "../blocks/galleryUpload/galleryUpload.css";
import ModalWithForm from "./ModalWithForm";

const AddGalleryModal = ({
  isOpen,
  onAddGalleryItems,
  onAddGalleryLink,
  handleCloseModal,
  isLoading,
}) => {
  const [mode, setMode] = useState("upload");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [title, setTitle] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const [linkKind, setLinkKind] = useState("photo");
  const [linkUrl, setLinkUrl] = useState("");
  const fileInputRef = useRef(null);

  const addFiles = (fileList) => {
    const incoming = Array.from(fileList).filter(
      (file) => file.type.startsWith("image/") || file.type.startsWith("video/")
    );
    setSelectedFiles((prev) => [...prev, ...incoming]);
  };

  const handleFileChange = (e) => {
    addFiles(e.target.files);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    addFiles(e.dataTransfer.files);
  };

  const removeFile = (indexToRemove) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const resetForm = () => {
    setSelectedFiles([]);
    setTitle("");
    setLinkUrl("");
    setLinkKind("photo");
    setMode("upload");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (mode === "upload") {
      if (selectedFiles.length === 0) return;
      onAddGalleryItems(selectedFiles, title);
    } else {
      if (!linkUrl) return;
      onAddGalleryLink({ kind: linkKind, url: linkUrl, title });
    }
    resetForm();
  };

  const handleClose = () => {
    resetForm();
    handleCloseModal();
  };

  const canSubmit =
    mode === "upload" ? selectedFiles.length > 0 : linkUrl.trim().length > 0;

  return (
    <ModalWithForm
      title="Add to album"
      onClose={handleClose}
      isOpen={isOpen}
      onSubmit={handleSubmit}
    >
      <div className="modal__weather-type">
        <p className="modal__weather-title">How are you adding this?</p>
        <div>
          <input
            type="radio"
            name="galleryMode"
            id="gallery-mode-upload"
            value="upload"
            checked={mode === "upload"}
            onChange={() => setMode("upload")}
          />
          <label htmlFor="gallery-mode-upload">Upload a file</label>
        </div>
        <div>
          <input
            type="radio"
            name="galleryMode"
            id="gallery-mode-link"
            value="link"
            checked={mode === "link"}
            onChange={() => setMode("link")}
          />
          <label htmlFor="gallery-mode-link">Add a link</label>
        </div>
      </div>

      {mode === "upload" ? (
        <>
          <div
            className={`galleryUpload__dropzone${
              isDragging ? " galleryUpload__dropzone_active" : ""
            }`}
            onDragOver={(e) => {
              e.preventDefault();
              setIsDragging(true);
            }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={handleDrop}
          >
            <p className="galleryUpload__dropzone-text">
              Drag photos or videos here, or click to browse
            </p>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*,video/*"
              multiple
              onChange={handleFileChange}
              className="galleryUpload__input"
            />
          </div>

          {selectedFiles.length > 0 && (
            <ul className="galleryUpload__preview-list">
              {selectedFiles.map((file, index) => (
                <li className="galleryUpload__preview-item" key={`${file.name}-${index}`}>
                  <span className="galleryUpload__preview-name">{file.name}</span>
                  <button
                    type="button"
                    className="galleryUpload__preview-remove"
                    onClick={() => removeFile(index)}
                    aria-label={`Remove ${file.name}`}
                  >
                    ×
                  </button>
                </li>
              ))}
            </ul>
          )}
        </>
      ) : (
        <>
          <div className="modal__weather-type">
            <p className="modal__weather-title">What kind of link?</p>
            <div>
              <input
                type="radio"
                name="linkKind"
                id="gallery-link-photo"
                value="photo"
                checked={linkKind === "photo"}
                onChange={(e) => setLinkKind(e.target.value)}
              />
              <label htmlFor="gallery-link-photo">Photo</label>
            </div>
            <div>
              <input
                type="radio"
                name="linkKind"
                id="gallery-link-video"
                value="video"
                checked={linkKind === "video"}
                onChange={(e) => setLinkKind(e.target.value)}
              />
              <label htmlFor="gallery-link-video">Video</label>
            </div>
          </div>
          <label className="modal__label">
            {linkKind === "photo" ? "Photo URL" : "Video URL"}
            <input
              type="url"
              value={linkUrl}
              onChange={(e) => setLinkUrl(e.target.value)}
              name="linkUrl"
              className="modal__input"
              id="gallery-link-url-input"
              placeholder={
                linkKind === "photo"
                  ? "https://example.com/photo.jpg"
                  : "https://youtube.com/watch?v=..."
              }
              required
            />
            <span className="modal__error"></span>
          </label>
        </>
      )}

      <label className="modal__label">
        Title (optional)
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          name="title"
          className="modal__input"
          id="gallery-title-input"
          placeholder="Give it a name"
          maxLength="60"
        />
        <span className="modal__error"></span>
      </label>

      <button
        type="submit"
        className="modal__submit-button_items"
        disabled={!canSubmit || isLoading}
      >
        {isLoading
          ? "Adding..."
          : mode === "upload"
          ? `Add ${selectedFiles.length || ""} to album`
          : "Add link"}
      </button>
    </ModalWithForm>
  );
};

export default AddGalleryModal;
